import React, { useState, useEffect } from 'react';
import { Utilities } from '../../../MedicareProAPI/Utilities/Utilities';

import * as Chartist from 'chartist';

export default function LineChart(props) {
  const newChartId = 'chart-' + Math.floor(Math.random() * 100000);
  const elementProps = { className: props.className || undefined };

  const defaultChartOptions = {
    showArea: true,
    showLine: true,
    showPoint: true,
    fullWidth: true,
    axisX: {
      showLabel: true,
      showGrid: false,
    },
    axisY: {
      showGrid: false,
    },
    chartPadding: { left: 40 },
  };

  const [chart, setChart] = useState(null);
  const [chartId, setChartId] = useState(newChartId);

  useEffect(() => {
    if (!chart) {
      let newChart = new Chartist.LineChart(
        '#' + chartId,
        props.data || undefined,
        props.options
          ? Utilities.merge(defaultChartOptions, props.options)
          : { ...defaultChartOptions },
        props.responsiveOptions || undefined
      );

      setChart(newChart);
    } else {
    }
  }, [props.data, props.options, props.responsiveOptions]);

  return chartId && <div {...elementProps} id={chartId} />;
}
